import { PersonRoleFilter, PersonStatusFilter } from '@myrewards/contracts';
import type { PeopleFilters } from '../../api/admin';

/** The People filters, read from the address so a view can be shared and reloaded. */
export function filtersFrom(params: URLSearchParams): PeopleFilters {
  const q = params.get('q')?.trim();
  const sector = params.get('sector')?.trim();
  const role = PersonRoleFilter.safeParse(params.get('role'));
  const status = PersonStatusFilter.safeParse(params.get('status'));
  return {
    ...(q !== undefined && q !== '' && { q }),
    ...(sector !== undefined && sector !== '' && { sector }),
    ...(role.success && { role: role.data }),
    status: status.success ? status.data : 'all',
  };
}

/** The People address with some parameters changed (null removes one). */
export function peopleHref(params: URLSearchParams, change: Record<string, string | null>): string {
  const next = new URLSearchParams(params);
  // Opening a record keeps the page; changing what the list holds starts it again from page 1.
  if (Object.keys(change).some((key) => key !== 'person')) next.delete('page');
  for (const [key, value] of Object.entries(change))
    if (value === null || value === '') next.delete(key);
    else next.set(key, value);
  const query = next.toString();
  return query === '' ? '/settings/system/people' : `/settings/system/people?${query}`;
}
